import { FormControl, FormErrorMessage, Flex, Text } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import Input from "../inputs/Input";
import { forwardRef, useImperativeHandle } from "react";
import { Center } from "../../types/center.types";
import { fPhoneNumber } from "../../lib/format";

type CenterFormProps = {
	value?: Center;
};

export type CenterFormHandler = {
	values: () => Partial<Center>;
	valid: () => Promise<boolean>;
};

const CenterForm = forwardRef<CenterFormHandler, CenterFormProps>(
	({ value }: CenterFormProps, ref) => {
		const methods = useForm();

		useImperativeHandle(ref, () => ({
			valid: () => {
				return methods.trigger();
			},
			values: () => {
				const data = methods.getValues();
				return {
					email: data.email,
					name: data.name,
					phoneNumber: data.phoneNumber,
					shippingAddress: {
						streetNumber: data.shippingAddressStreetNumber,
						streetName: data.shippingAddressStreetName,
						postalCode: data.shippingAddressPostalCode,
						city: data.shippingAddressCity,
						country: data.shippingCountry,
					},
					sageId: data.sageId,
				};
			},
		}));
		return (
			<FormProvider {...methods}>
				<form style={{ marginTop: "32px" }}>
					<Flex direction="column" gap="24px">
						<FormControl isInvalid={!!methods.formState.errors.name}>
							<Input
								id="name"
								placeholder="Nom du centre"
								defaultValue={value?.name ?? ""}
								{...methods.register("name", {
									required: "Ce champ est obligatoire",
								})}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.name?.message}</>
							</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!methods.formState.errors.phoneNumber}>
							<Input
								id="phoneNumber"
								placeholder="Téléphone"
								defaultValue={fPhoneNumber(value?.phoneNumber ?? "")}
								{...methods.register("phoneNumber", {
									required: "Ce champ est obligatoire",
								})}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.phoneNumber?.message}</>
							</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!methods.formState.errors.email}>
							<Input
								id="email"
								placeholder="Email"
								defaultValue={value?.email ?? ""}
								{...methods.register("email")}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.email?.message}</>
							</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!methods.formState.errors.sageId}>
							<Input
								id="sageId"
								placeholder="ID Sage"
								defaultValue={value?.sageId ?? ""}
								{...methods.register("sageId")}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.sageId?.message}</>
							</FormErrorMessage>
						</FormControl>

						<Text>Adresse de livraison</Text>
						<Flex gap={4}>
							<FormControl
								isInvalid={
									!!methods.formState.errors.shippingAddressStreetNumber
								}
								width={"10rem"}
							>
								<Input
									id="shippingAddressStreetNumber"
									placeholder="Numéro"
									defaultValue={value?.shippingAddress?.streetNumber ?? ""}
									{...methods.register("shippingAddressStreetNumber", {
										required: "Ce champ est obligatoire",
									})}
								></Input>
								<FormErrorMessage>
									<>
										{
											methods.formState.errors?.shippingAddressStreetNumber
												?.message
										}
									</>
								</FormErrorMessage>
							</FormControl>

							<FormControl
								isInvalid={!!methods.formState.errors.shippingAddressStreetName}
							>
								<Input
									id="shippingAddressStreetName"
									placeholder="Adresse (Rue, Avenue, ...)"
									defaultValue={value?.shippingAddress?.streetName ?? ""}
									{...methods.register("shippingAddressStreetName", {
										required: "Ce champ est obligatoire",
									})}
								></Input>
								<FormErrorMessage>
									<>
										{
											methods.formState.errors?.shippingAddressStreetName
												?.message
										}
									</>
								</FormErrorMessage>
							</FormControl>
						</Flex>

						<Flex gap={4}>
							<FormControl
								isInvalid={!!methods.formState.errors.shippingAddressPostalCode}
								width={"10rem"}
							>
								<Input
									id="shippingAddressPostalCode"
									placeholder="Code postal."
									defaultValue={value?.shippingAddress?.postalCode ?? ""}
									{...methods.register("shippingAddressPostalCode", {
										required: "Ce champ est obligatoire",
									})}
								></Input>
								<FormErrorMessage>
									<>
										{
											methods.formState.errors?.shippingAddressPostalCode
												?.message
										}
									</>
								</FormErrorMessage>
							</FormControl>

							<FormControl
								isInvalid={!!methods.formState.errors.shippingAddressCity}
							>
								<Input
									id="shippingAddressCity"
									placeholder="Ville"
									defaultValue={value?.shippingAddress?.city ?? ""}
									{...methods.register("shippingAddressCity", {
										required: "Ce champ est obligatoire",
									})}
								></Input>
								<FormErrorMessage>
									<>{methods.formState.errors?.shippingAddressCity?.message}</>
								</FormErrorMessage>
							</FormControl>
						</Flex>
						<FormControl isInvalid={!!methods.formState.errors.shippingCountry}>
							<Input
								id="shippingCountry"
								placeholder="Pays"
								defaultValue={value?.shippingAddress?.country ?? ""}
								{...methods.register("shippingCountry", {
									required: "Ce champ est obligatoire",
								})}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.shippingCountry?.message}</>
							</FormErrorMessage>
						</FormControl>
					</Flex>
				</form>
			</FormProvider>
		);
	},
);

export default CenterForm;
